<template>
    <b-modal
        ref="dialog"
        title-tag="h2"
        :lazy="true"
        @hidden="close"
        :title="title"
    >
        <p class="message">
            Setting this patient’s status to {{ type.toLowerCase() }} will
            deactivate all of the patient’s future appointments, and you will
            not be able to create new records for this patient.
        </p>

        <b-form-group label-cols="3" label="Date:" label-for="date">
            <date-picker
                :config="{ format: getDateFormat() }"
                v-model="date"
                placeholder="Date (required)"
            />
        </b-form-group>

        <b-form-group label-cols="3" label="Reminders:" label-for="reminders">
            <b-select v-model="reminders">
                <option value="0" selected="selected">
                    Deactivate existing reminders
                </option>
                <option value="1">Keep existing reminders</option>
            </b-select>
        </b-form-group>

        <b-form-group label-cols="3" label="Tasks:" label-for="tasks">
            <b-select v-model="tasks">
                <option value="0" selected="selected">
                    Deactivate existing tasks
                </option>
                <option value="1">Keep existing tasks</option>
            </b-select>
        </b-form-group>

        <b-form-group label-cols="3" label="Notes:" label-for="notes">
            <b-textarea v-model="notes" placeholder="Notes (optional)" />
        </b-form-group>

        <template v-slot:modal-footer>
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="cancel"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button v-if="!isLoading" variant="primary" @click="save">
                Save
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import moment from "moment";
import Loader from "@/module/commons/loader";
import { DateTime } from "luxon";

export default {
    components: {
        Loader
    },
    data() {
        return {
            type: "", // INACTIVE | DECEASED
            title: "",
            isLoading: false,
            notes: "",
            reminders: "0",
            tasks: "0",
            date: ""
        };
    },
    methods: {
        open(params = {}) {
            if (params.type === "INACTIVE") {
                this.title = "Deactivate Patient";
            } else if (params.type === "DECEASED") {
                this.title = "Mark As Deceased";
            }

            this.type = params.type;
            this.date = moment()
                .tz(this._timeZone)
                .format(this.getDateFormat());

            this.$refs.dialog.show();
        },
        close() {
            this.$refs.dialog.hide();
        },
        cancel() {
            this.$emit("cancel");
            this.close();
        },
        save() {
            this.$emit("save", {
                notes: this.notes,
                reminders: Number(this.reminders),
                tasks: Number(this.tasks),
                date: this.fromDateToLuxon(this.date).toSeconds()
            });
            this.close();
        },
        fromDateToLuxon(formattedDate) {
            return formattedDate
                ? DateTime.fromFormat(formattedDate, this._dateFormat, {
                      zone: this._timeZone
                  })
                : null;
        }
    }
};
</script>

<style scoped>
p.message {
    border-bottom: 1px solid #ddd;
    margin-bottom: 15px;
    padding-bottom: 15px;
}
</style>
